import type { HTMLAttributes, LabelHTMLAttributes, ReactElement, ReactNode } from 'react';
import { cn } from '@/lib/cn';

type CommonProps = {
  isRequired?: boolean;
  children?: ReactNode;
};

type SpanMicroProps = HTMLAttributes<HTMLSpanElement> &
  CommonProps & { as?: 'span' };

type LabelMicroProps = LabelHTMLAttributes<HTMLLabelElement> &
  CommonProps & { as: 'label' };

export type MicroProps = SpanMicroProps | LabelMicroProps;

function RequiredMark(): ReactElement {
  return (
    <span aria-hidden className="ml-0.5 text-[var(--err)]">*</span>
  );
}

export function Micro(props: MicroProps): ReactElement {
  const { isRequired = false, children, className, ...rest } = props;
  const merged = cn('micro', className);
  if (props.as === 'label') {
    const labelProps = rest as LabelHTMLAttributes<HTMLLabelElement>;
    return (
      <label className={merged} {...labelProps}>
        {children}
        {isRequired && <RequiredMark />}
      </label>
    );
  }
  const spanProps = rest as HTMLAttributes<HTMLSpanElement>;
  return (
    <span className={merged} {...spanProps}>
      {children}
      {isRequired && <RequiredMark />}
    </span>
  );
}
